import { Component, Inject } from '@angular/core';
import { Environment } from '../../classes/environment';


@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrl: "./footer.component.scss"
})
export class FooterComponent {


	version: string = this.environment.version;


	constructor(
		@Inject('environment') public environment: Environment,
	) {}

	
}
